import { render, staticRenderFns } from "./NotificationComponent.vue?vue&type=template&id=021f2850&scoped=true&"
import script from "./NotificationComponent.vue?vue&type=script&lang=js&"
export * from "./NotificationComponent.vue?vue&type=script&lang=js&"
import style0 from "./NotificationComponent.vue?vue&type=style&index=0&id=021f2850&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021f2850",
  null
  
)

export default component.exports